module.exports = __webpack_public_path__ + "img/pic_5_tc.d89a0454.png";